import React from 'react';
import { Helmet } from 'react-helmet-async';
 // ✅ Import Helmet
import OrderConfirmationPage from '../elementsui/OrderConfirmationPage';

const OrderConfirmation = () => {
  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Order Confirmed | binzal - Thank You for Shopping!</title>
        <meta name="description" content="Your binzal order has been placed successfully. We’re preparing your delivery with care and speed across Bihar." />
        <meta name="keywords" content="binzal order confirmation, order success, grocery delivery placed Bihar" />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Order Confirmed | binzal" />
        <meta property="og:description" content="Your grocery order is confirmed on binzal. Get ready for fast delivery across Bihar." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <OrderConfirmationPage />
    </div>
  );
};

export default OrderConfirmation;
